import { render, staticRenderFns } from "./ChallengeList.vue?vue&type=template&id=1da66762&scoped=true&"
import script from "./ChallengeList.vue?vue&type=script&lang=js&"
export * from "./ChallengeList.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeList.vue?vue&type=style&index=0&id=1da66762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da66762",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow,VSkeletonLoader,VSwitch})
